import Str from '@supercharge/strings';
import { Moment } from 'moment';

export default class InvoiceNumberGenerator {
    static make(format: string, padding: number, number: number, startingAt?: Moment, trueDate?: Moment): string {
        const currentYear = this.getPlaceholderDate(startingAt, trueDate);
        const previousYear = currentYear.clone().subtract(1, 'year');
        const nextYear = currentYear.clone().add(1, 'year');

        return Str(format)
            .replace('%number%', number.toString().padStart(padding, '0'))
            .replace('%previous_year%', previousYear.format('YYYY').toString())
            .replace('%previous_year2%', previousYear.format('YY').toString())
            .replace('%year%', currentYear.clone().format('YYYY').toString())
            .replace('%year2%', currentYear.clone().format('YY').toString())
            .replace('%next_year%', nextYear.format('YYYY').toString())
            .replace('%next_year2%', nextYear.format('YY').toString())
            .replace('%month%', currentYear.clone().format('MM').toString())
            .toString();
    }

    private static getPlaceholderDate(startingAt?: Moment, trueDate?: Moment) {
        trueDate = trueDate ?? moment();
        const now = trueDate.clone();
        // January ending follows standard conditions.
        if (!startingAt || startingAt.month() === 0) {
            return now;
        }

        if (trueDate.isSameOrAfter(startingAt)) {
            return now.add(1, 'year');
        }

        return now;
    }
}
